import {HeaderProps} from "@/elements-react/catalog-layout/header/index.tsx";
import {Templates, useTemplate} from "@/util-react/template.tsx";
import {HeaderDesktopDefault} from "@/elements-react/catalog-layout/header/templates/header.default.tsx";
import {HeaderDesktopBlackAndBlue} from "@/elements-react/catalog-layout/header/templates/header.black-and-blue.tsx";

const templates: Record<Templates, React.ComponentType<HeaderProps>> = {
    [Templates.DEFAULT]: HeaderDesktopDefault,
    [Templates.BLACK_AND_BLUE]:  HeaderDesktopBlackAndBlue,
};

export const HeaderDesktop = (props: HeaderProps) => {
    const template = useTemplate();
    const TemplatedComponent = templates[template.template ?? Templates.DEFAULT];

    return <TemplatedComponent {...props} />;
};